// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LkL2","colMin":"styles_colMin__cIwCB"};